import React from "react";

import { Col, Flex, Row } from "antd";

import { Spin } from "components";

export type PageSpinProps = {
  className?: string;
  fullHeight?: boolean;
};

export const PageSpin = ({ className = "", fullHeight = true }: PageSpinProps) => (
  <section className={`container ${className}`}>
    <Row justify="space-around" align="middle" className={`${fullHeight ? "full-height-minus-header" : ""}`}>
      <Col className="center">
        <Spin size="large" dataTestId="page-spin" />
      </Col>
    </Row>
  </section>
);

export const FlexPageSpin = () => (
  <Flex align="center" justify="center" style={{ minHeight: "20rem" }}>
    <Spin size="large" dataTestId="flex-page-spin" />
  </Flex>
);

export default PageSpin;
